// extracted by mini-css-extract-plugin
export var background = "VideoCardArticlesList-module--background--e27a2";